import {Card, Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import "./AboutMain.css";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import CommonQuill from "../../components/editor/CommonQuill";
import HelperService from "../../utility/HelperService";
interface AddAboutMainProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
}
const AddAboutMain = ({ show, handleClose, data }: AddAboutMainProps) => {
  const [isLoading, setLoading] = useState(false);
  const [bannerFile, setBannerFile] = useState<File | null>(null);
  const [missionFile, setMissionFile] = useState<File | null>(null);
  const [visionFile, setVisionFile] = useState<File | null>(null);
  const [value, setValue] = useState("");
  const [fileError, setFileError] = useState<string>("");
  const quillRef = useRef<any>(null);
  const [highlights, setHighlights] = useState<
    { title: string; sub_title: string; icon: string | null }[]
  >([{ title: "", sub_title: "", icon: null }]);
  const [mission, setMission] = useState<
    { title: string; description: string; icon: string | null }[]
  >([{ title: "", description: "", icon: null }]);
  const [vision, setVision] = useState<
    { title: string; description: string; icon: string | null }[]
  >([{ title: "", description: "", icon: null }]);
  const [customErrors, setCustomErrors] = useState<{
    description?: string;
  }>({});
  const getFileName = (url: string | null) => {
    if (!url) return null;
    return decodeURIComponent(url.split("/").pop()?.split("?")[0] || "");
  };  
  useEffect(() => {
    if (data) {
      // setValue(data.description || "");
      if (data.highlights == 0) {
        setHighlights([{ title: "",sub_title: "", icon: null }]);
      } else {
        setHighlights(
          data.highlights.map((h: any) => ({
            title: h.title,
            sub_title: h.sub_title,
            icon: h.icon,
          }))
        );
      }
      if (data.mission == 0) {
        setMission([{ title: "", description: "", icon: null }]);
      } else {
        setMission(
          data.mission.map((m: any) => ({
            title: m.title,
            description: m.description,
            icon: m.icon,
          }))
        );
      }
      if (data.vision == 0) {
        setVision([{ title: "", description: "", icon: null }]);
      } else {
        setVision(
          data.vision.map((v: any) => ({
            title: v.title,
            description: v.description,
            icon: v.icon,
          }))
        );
      }
    }
  }, [data, show]);

  const isQuillEmpty = (value?: string) => {
  if (!value) return true;

  const text = value
    .replace(/<(.|\n)*?>/g, "") // remove HTML tags
    .replace(/&nbsp;/g, "")     // remove spaces
    .trim();

  return text.length === 0;
};

  const onSubmit = async () => {
    setLoading(true);

    const editor = quillRef.current?.getEditor();
  const html = editor?.root.innerHTML || "";

  if (isQuillEmpty(html)) {
    setCustomErrors({ description: "Description is required" });
    toast.error("Description is required");
    setLoading(false);
    return;
  }

    if (fileError) {
      toast.error(fileError);
      return;
    }
    // ✅ Vision validation
    const visionErrors: string[] = [];
    for (let i = 0; i < vision.length; i++) {
      const errors: string[] = [];
      if (!vision[i].icon) errors.push("Image");
      if (!vision[i].title.trim()) errors.push("Title");
      if (!vision[i].description.trim()) errors.push("Description");
      if (errors.length > 0) {
        visionErrors.push(`Vision: ${errors.join(", ")} is required`);
      }
    }
    if (visionErrors.length > 0) {
      visionErrors.forEach((err) => toast.error(err));
      setLoading(false);
      return;
    }

    // ✅ Mission validation
    const missionErrors: string[] = [];
    for (let i = 0; i < mission.length; i++) {
      const errors: string[] = [];
      if (!mission[i].icon) errors.push("Image");
      if (!mission[i].title.trim()) errors.push("Title");
      if (!mission[i].description.trim()) errors.push("Description");
      if (errors.length > 0) {
        missionErrors.push(`Mission: ${errors.join(", ")} is required`);
      }
    }
    if (missionErrors.length > 0) {
      missionErrors.forEach((err) => toast.error(err));
      setLoading(false);
      return;
    }

    const formData = new FormData();
    if (bannerFile) {
      formData.append("banner", bannerFile);
    }
    formData.append("description", html);  //quillRef?.getHtml()
    if (
      highlights.length > 0 &&
      highlights.some((h) => h.title.trim() !== "")
    ) {
      formData.append("highlights", JSON.stringify(highlights));
    }
    if (
      mission.length > 0 &&
      mission.some((m) => m.title.trim() !== "" || m.description.trim() !== "")
    ) {
      formData.append("mission", JSON.stringify(mission));
    }
    if (
      vision.length > 0 &&
      vision.some((m) => m.title.trim() !== "" || m.description.trim() !== "")
    ) {
      formData.append("vision", JSON.stringify(vision));
    }
    WebService.fileUploadAPI({
      action: `about/addUpdateAbout`,
      body: formData,
    })
      .then((res: any) => {
        toast.success(res.message);
        setLoading(false);
        handleClose();
      })
      .catch((err: any) => {
        setLoading(false);
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };
  const uploadFile = (
    file: File,
    index: number,
    section: "highlights" | "mission" | "vision"
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("storage", "ABOUT_US");
    WebService.fileUploadAPI({
      action: `upload`,
      body: formData,
    })
      .then((res: any) => {
        if (res.data?.url) {
          if (section === "highlights") {
            const newHighlights = [...highlights];
            newHighlights[index].icon = res.data.url;
            setHighlights(newHighlights);
          } else if (section === "mission") {
            const newMission = [...mission];
            newMission[index].icon = res.data.url;
            setMission(newMission);
          } else if (section === "vision") {
            const newVision = [...vision];
            newVision[index].icon = res.data.url;
            setVision(newVision);
          }
        }
      })
      .catch((err: any) => {
        toast.error(
          err.response?.data?.message || "Error while uploading image"
        );
      });
  };
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];
  const imageHandler = () => {
    // alert("g");
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.click();

    input.onchange = async () => {
      const file = input.files?.[0];
      console.log("fileeeee", file);
      if (!file) return;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("storage", "ABOUT_US");

      try {
        const res: any = await WebService.fileUploadAPI({
          action: "upload",
          body: formData,
        });

        const imageUrl = res?.data?.url; // ✅ correct access

        if (!imageUrl) {
          toast.error("Image upload failed");
          return;
        }

        if (!quillRef.current) return;
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);

        editor.insertEmbed(range.index, "image", imageUrl);
        editor.setSelection(range.index + 1);
      } catch (err) {
        toast.error("Image upload failed");
      }
    };
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          handleClose();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>About</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group className="mb-2" controlId="eventImage">
              <Form.Label className="label">Banner</Form.Label>
              {/* 🔹 Just info message, NOT validation */}
              <div
                className="text-primary mt-1"
                style={{ fontSize: "13px" }}
              >
                Note: Please upload an image of size:{" "}
                <strong>590 × 445 px</strong> in{" "}
                <strong>.png, .jpeg, .jpg or .svg</strong> format.
              </div>
              <Form.Control
                type="file"
                accept=".png,.jpg,.jpeg,.svg"
                className="custom-image-upload"
                onChange={(e) => {
                  const input = e.target as HTMLInputElement;
                  const selectedFile = input.files?.[0];

                  if (!selectedFile) return;

                  if (!ALLOWED_IMAGE_TYPES.includes(selectedFile.type)) {
                    setFileError(
                      "Image format not supported. Please upload PNG, JPG, JPEG or SVG. image"
                    );
                    // console.log(fileError)
                    //      toast.error(fileError);
                    setBannerFile(null);
                    input.value = ""; // reset input
                    return;
                  }

                  // ✅ valid
                  setFileError("");
                  setBannerFile(selectedFile);
                }}
              />
              {fileError && (
                <p className="text-danger mt-1" style={{ fontSize: "13px" }}>
                  {fileError}
                </p>
              )}
            </Form.Group>
            {(bannerFile || data?.banner) && (
              <div className="mb-2 event-image">
                <img
                  src={
                    bannerFile ? URL.createObjectURL(bannerFile) : data?.banner
                  }
                  alt="Event"
                  style={{
                    maxWidth: "100%",
                    maxHeight: 200,
                    objectFit: "contain",
                  }}
                />
              </div>
            )}
            <Form.Group className="mb-2" controlId="eventDescription">
              <Form.Label className="label">Description</Form.Label>{" "}
              <span className="text-danger">*</span>
              {/* <ReactQuill
                ref={quillRef}
                theme="snow"
                value={value}
                onChange={setValue}
                className="editor"
                modules={{
                  toolbar: {
                    container: [
                      // [
                      //   {
                      //     size: [
                      //       "8px",
                      //       "10px",
                      //       "12px",
                      //       "14px",
                      //       "16px",
                      //       "18px",
                      //       "24px",
                      //       "32px",
                      //       "48px",
                      //     ],
                      //   },
                      // ],

                      ["bold", "italic", "underline"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      [{ indent: "-1" }, { indent: "+1" }],
                      [{ size: ["small", false, "large"] }],
                      [{ color: [] }, { background: [] }],
                      ["link", "image", "emoji"],
                      ["clean"],
                    ],
                    handlers: {
                      image: () =>
                        quillImageHandler({
                          quillRef,
                          storage: "ABOUT_US", 
                        }),
                    },
                  },

                  "emoji-toolbar": true,
                  "emoji-textarea": true,
                  "emoji-shortname": true,
                }}
              /> */}
              <CommonQuill
                ref={quillRef}
                value={value}
                onChange={setValue}
                storage="ABOUT_US"
                initialHtml={show && data?.description ? HelperService.normalizeResizeHtml(data.description) : undefined}
                onClearError={() =>
                  setCustomErrors((p) => ({
                    ...p,
                    description: undefined,
                  }))
                }
              />
              {customErrors.description && (
                <div className="error-message">{customErrors.description}</div>
              )}

            </Form.Group>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Highlights
              </span>
            <Form.Group className="mb-2" controlId="highlights">
              <Form.Label className="label">Highlights</Form.Label>
                {/* <div className="highlight-wrapper"> */}
                  {highlights.map((highlight, index) => (
                    <div
                      key={index}
                      draggable
                      onDragStart={(e) => {
                        e.dataTransfer.setData("highlightIndex", index.toString());
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        const fromIndex = Number(
                          e.dataTransfer.getData("highlightIndex")
                        );
                        if (fromIndex === index) return;
                        const newHighlights = [...highlights];
                        const [moved] = newHighlights.splice(fromIndex, 1);
                        newHighlights.splice(index, 0, moved);
                        setHighlights(newHighlights);
                      }}
                      style={{ cursor: "move" }}
                    
                >
                  <div className="d-flex align-items-start">
                    <span
                      style={{
                        cursor: "grab",
                        marginRight: 8,
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20,
                        color: "#888",
                        marginTop: 10,
                      }}
                      title="Drag to reorder"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <circle cx="5" cy="6" r="1.5" />
                        <circle cx="5" cy="10" r="1.5" />
                        <circle cx="5" cy="14" r="1.5" />
                        <circle cx="11" cy="6" r="1.5" />
                        <circle cx="11" cy="10" r="1.5" />
                        <circle cx="11" cy="14" r="1.5" />
                      </svg>
                    </span>
                    <div style={{ flex: 1 }} className="highlight-item">
                      <Form.Control
                        type="file"
                        accept="image/png,image/jpeg,image/svg+xml"
                        className="custom-image-upload"
                        onChange={(e) => {
                          const input = e.target as HTMLInputElement;
                          const file = input.files?.[0];

                          if (!file) return;

                          if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                            const msg =
                              "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                            setFileError(msg);
                            toast.error(msg);
                            input.value = "";
                            return;
                          }
                          setFileError("");
                          uploadFile(file, index, "highlights");
                        }}
                      />
                      {/* {highlights[index].icon && (
                        <small className="text-muted d-block mt-1">
                          📎 {getFileName(highlights[index].icon)}
                        </small>
                      )} */}
                      {highlights[index] && (
                        <img
                          src={
                            highlights[index].icon
                              ? highlights[index].icon
                              : data?.highlights?.[index]?.imageUrl || ""
                          }
                          className="mt-2"
                          style={{
                            maxWidth: "100%",
                            maxHeight: 200,
                            objectFit: "contain",
                          }}
                        />
                      )}
                      <div className="mt-2">
                        <Form.Control
                          type="text"
                          placeholder={`Title`}
                          value={highlight.title}
                          onChange={(e) => {
                            const newHighlights = [...highlights];
                            newHighlights[index].title = e.target.value;
                            setHighlights(newHighlights);
                          }}
                        />
                        <div className="d-flex align-items-center mt-2">
                        <Form.Control
  type="text"
  placeholder="Subtitle"
  className="mt-2"
  value={highlight.sub_title}
  onChange={(e) => {
    const newHighlights = [...highlights];
    newHighlights[index].sub_title = e.target.value;
    setHighlights(newHighlights);
  }}
/>
                        <div className="d-flex ms-2">
                          <PlusSquareFill
                            onClick={() => {
                              setHighlights([
                                ...highlights,
                                { title: "",sub_title: "", icon: null },
                              ]);
                            }}
                            className="ms-2 me-2 cursor-pointer"
                          />
                          {highlights.length > 1 && (
                            <DashSquareFill
                              onClick={() => {
                                const newHighlights = highlights.filter(
                                  (_, i) => i !== index
                                );
                                setHighlights(newHighlights);
                              }}
                              className="cursor-pointer"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              ))}
              <div
                className="text-primary mt-1"
                style={{ fontSize: "13px" }}
              >
                Note: Please upload an image of size:{" "}
                <strong>72 × 72 px</strong> in{" "}
                <strong>.png, .jpeg, .jpg or .svg</strong> format.
              </div>
            </Form.Group>
            </Card>

           <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Vision
              </span>
            <Form.Group className="mb-2" controlId="vision">
              <Form.Label className="label" style={{ fontSize: "13px" }}>
                Vision <span className="text-danger">*</span>
              </Form.Label>
              <div>
                {vision.map((item, index) => (
                  <div
                    key={index}
                    // draggable
                    // onDragStart={(e) => {
                    //   e.dataTransfer.setData("visionIndex", index.toString());
                    // }}
                    // onDragOver={(e) => e.preventDefault()}
                    // onDrop={(e) => {
                    //   const fromIndex = Number(
                    //     e.dataTransfer.getData("visionIndex")
                    //   );
                    //   if (fromIndex === index) return;
                    //   const newVision = [...vision];
                    //   const [moved] = newVision.splice(fromIndex, 1);
                    //   newVision.splice(index, 0, moved);
                    //   setVision(newVision);
                    // }}
                    // style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start">
                      {/* <span
                        style={{
                          cursor: "grab",
                          marginRight: 8,
                          display: "flex",
                          alignItems: "center",
                          fontSize: 20,
                          color: "#888",
                          marginTop: 10,
                        }}
                        title="Drag to reorder"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <circle cx="5" cy="6" r="1.5" />
                          <circle cx="5" cy="10" r="1.5" />
                          <circle cx="5" cy="14" r="1.5" />
                          <circle cx="11" cy="6" r="1.5" />
                          <circle cx="11" cy="10" r="1.5" />
                          <circle cx="11" cy="14" r="1.5" />
                        </svg>
                      </span> */}
                      <div style={{ flex: 1 }} className="highlight-item">
                        <Form.Control
                          type="file"
                          accept="image/png,image/jpeg,image/svg+xml"
                          className="custom-image-upload"
                          onChange={(e) => {
                            const input = e.target as HTMLInputElement;
                            const file = input.files?.[0];

                            if (!file) return;

                            if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                              const msg =
                                "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                              setFileError(msg);
                              toast.error(msg);
                              input.value = "";
                              return;
                            }

                            if (file) {
                              uploadFile(file, index, "vision");
                            }
                            setFileError("");
                          }}
                        />
                        {vision[index] && (
                          <img
                            src={
                              vision[index].icon
                                ? vision[index].icon
                                : data?.vision?.[index]?.imageUrl || ""
                            }
                            className="mt-2"
                            style={{
                              maxWidth: "100%",
                              maxHeight: 200,
                              objectFit: "contain",
                            }}
                          />
                        )}
                        <div className="d-flex">
                          <Form.Control
                            type="text"
                            placeholder={`Title *`}
                            value={item.title}
                            onChange={(e) => {
                              const newVision = [...vision];
                              newVision[index].title = e.target.value;
                              setVision(newVision);
                            }}
                          />
                          {/* <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setMission([...mission, { title: '', description: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {mission.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newMission = mission.filter((_, i) => i !== index);
                                                                setMission(newMission);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div> */}
                        </div>
                        <Form.Control
                          as="textarea"
                          placeholder={`Description *`}
                          value={item.description}
                          onChange={(e) => {
                            const newVision = [...vision];
                            newVision[index].description = e.target.value;
                            setVision(newVision);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <p
                className="text-primary mt-1"
                style={{ fontSize: "13px" }}
              >
                Note: Please upload an image of size:{" "}
                <strong>44 × 44 px</strong> in{" "}
                <strong>.png, .jpeg, .jpg or .svg</strong> format.
              </p>
            </Form.Group>
            </Card>

            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Mission
              </span>
            <Form.Group className="mb-2" controlId="mission">
              <Form.Label className="label" style={{ fontSize: "13px" }}>
                Mission <span className="text-danger">*</span>
              </Form.Label>

              <div>
                {mission.map((item, index) => (
                  <div
                    key={index}
                    // draggable
                    // onDragStart={(e) => {
                    //   e.dataTransfer.setData("missionIndex", index.toString());
                    // }}
                    // onDragOver={(e) => e.preventDefault()}
                    // onDrop={(e) => {
                    //   const fromIndex = Number(
                    //     e.dataTransfer.getData("missionIndex")
                    //   );
                    //   if (fromIndex === index) return;
                    //   const newMission = [...mission];
                    //   const [moved] = newMission.splice(fromIndex, 1);
                    //   newMission.splice(index, 0, moved);
                    //   setMission(newMission);
                    // }}
                    // style={{ cursor: "move" }}
                  >
                    <div className="d-flex align-items-start">
                      {/* <span
                        style={{
                          cursor: "grab",
                          marginRight: 8,
                          display: "flex",
                          alignItems: "center",
                          fontSize: 20,
                          color: "#888",
                          marginTop: 10,
                        }}
                        title="Drag to reorder"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <circle cx="5" cy="6" r="1.5" />
                          <circle cx="5" cy="10" r="1.5" />
                          <circle cx="5" cy="14" r="1.5" />
                          <circle cx="11" cy="6" r="1.5" />
                          <circle cx="11" cy="10" r="1.5" />
                          <circle cx="11" cy="14" r="1.5" />
                        </svg>
                      </span> */}
                      <div style={{ flex: 1 }} className="highlight-item">
                        <Form.Control
                          type="file"
                          accept="image/png,image/jpeg,image/svg+xml"
                          className="custom-image-upload"
                          onChange={(e) => {
                            const input = e.target as HTMLInputElement;
                            const file = input.files?.[0];

                            if (!file) return;

                            if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                              const msg =
                                "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                              setFileError(msg);
                              toast.error(msg);
                              input.value = "";
                              return;
                            }

                            if (file) {
                              uploadFile(file, index, "mission");
                            }
                            setFileError("");
                          }}
                        />
                        {mission[index] && (
                          <img
                            src={
                              mission[index].icon
                                ? mission[index].icon
                                : data?.mission?.[index]?.imageUrl || ""
                            }
                            className="mt-2"
                            style={{
                              maxWidth: "100%",
                              maxHeight: 200,
                              objectFit: "contain",
                            }}
                          />
                        )}
                        <div className="d-flex">
                          <Form.Control
                            type="text"
                            placeholder={`Title *`}
                            value={item.title}
                            onChange={(e) => {
                              const newMission = [...mission];
                              newMission[index].title = e.target.value;
                              setMission(newMission);
                            }}
                          />
                          {/* <div className="d-flex mt-2">
                                                        <PlusSquareFill
                                                            onClick={() => {
                                                                setMission([...mission, { title: '', description: '' }]);
                                                            }}
                                                            className="ms-2 me-2 cursor-pointer"
                                                        />
                                                        {mission.length > 1 && <DashSquareFill
                                                            onClick={() => {
                                                                const newMission = mission.filter((_, i) => i !== index);
                                                                setMission(newMission);
                                                            }}
                                                            className="cursor-pointer"
                                                        />}
                                                    </div> */}
                        </div>

                        <Form.Control
                          as="textarea"
                          placeholder={`Description *`}
                          value={item.description}
                          onChange={(e) => {
                            const newMission = [...mission];
                            newMission[index].description = e.target.value;
                            setMission(newMission);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <p
                className="text-primary mt-1"
                style={{ fontSize: "13px" }}
              >
                Note: Please upload an image of size:{" "}
                <strong>44 × 44 px</strong> in{" "}
                <strong>.png, .jpeg, .jpg or .svg</strong> format.
              </p>
            </Form.Group> 
            </Card>           
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={onSubmit}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddAboutMain;
